<template>
  <div class="step padding-top-ml">
    <div class="content">
      <div class="ri-medium-bold-headline">
        היי {{ firstName }}!
      </div>
      <div class="ri-large-body margin-top-xxs">
        נשלח לך במייל את כל הטיפים והתובנות של האתגר, מבטיחים לא להספים.
      </div>

      <email-input
        class="margin-top-l"
        label-text="אימייל"
        :value="email"
        :on-input="signupStore.setEmail"
        :error="emailError"
        :on-error="setEmailError"
      />
      <riseup-button
        class="next-button margin-top-m"
        :disabled="disabled"
        :title="'אפשר להמשיך'"
        size="small"
        :action="nextClicked"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>

import EmailInput from '@riseupil/base-ui/src/components/Inputs/EmailInput.vue';
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { useSignupStore } from '../../../stores/signup';
import SwitchToLogin from './SwitchToLogin.vue';
import Segment from '../../../Segment';

const signupStore = useSignupStore();
const { email, firstName } = storeToRefs(signupStore);

const emailError = ref(false);
const disabled = computed(() => email.value.length < 2 || emailError.value);
Segment.trackUserGot('Signup_EnterEmail_Shown');

const setEmailError = (value: boolean) => {
  emailError.value = value;
};

function nextClicked() {
  Segment.trackUserInteraction('Signup_EnterEmail_NextClicked', { email: email.value });
  signupStore.nextStep();
}

</script>
<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';

.step {
  @include white-page-frame;
  @include responsive-padding;
  flex: 1;
  width: 100%;

  .content {
    width: 100%;

    .next-button {
      height: 58px;
      width: 100%;
    }
  }
}
</style>
